/* CASE HABIT - customizer entry preview (DEV-compatible; no checkout/editor claims). */
(() => {
  "use strict";
  const roots = () => [...document.querySelectorAll("[data-ch-custom-root]")];
  function keepPreview(link) {
    const p = new URLSearchParams(location.search);
    const preview = p.get("preview_theme_id");
    const href = new URL(link.getAttribute("href"), location.origin);
    if (href.searchParams.has("ch_custom")) {
      if (preview) href.searchParams.set("preview_theme_id", preview);
      if (link.dataset.chTemplate) href.searchParams.set("template", link.dataset.chTemplate);
      link.href = href.pathname + href.search + href.hash;
    }
  }
  function initialize(root) {
    if (root.dataset.chCustomReady === "1") return;
    root.dataset.chCustomReady = "1";
    root.querySelectorAll("[data-ch-custom-link]").forEach(keepPreview);
    const search = new URLSearchParams(location.search);
    if (search.get("ch_custom") !== "1") return;
    const outer = root.closest("[id^='shopify-section-']") || root.closest(".shopify-section") || root;
    const main = root.closest("main") || document.getElementById("MainContent");
    if (main) {
      [...main.children].forEach(child => {
        if (child !== outer && !child.contains(root)) child.style.display = "none";
      });
    }
    const teaser=root.querySelector("[data-ch-custom-teaser]");
    const hub=root.querySelector("[data-ch-custom-hub]");
    if(teaser) teaser.hidden=true;
    const mobileCopy=root.querySelector(".ch-custom-banner__mobile-copy");
    if(mobileCopy) mobileCopy.hidden=true;
    if(hub) hub.hidden=false;
    const back=root.querySelector("[data-ch-custom-back]");
    if(back){
      const url=new URL(back.href,location.origin);
      const id=search.get("preview_theme_id");
      if(id)url.searchParams.set("preview_theme_id",id);
      back.href=url.pathname+url.search;
    }
    const selected=search.get("template");
    const indicator=root.querySelector("[data-ch-template-selection]");
    function pick(id) {
      root.querySelectorAll("[data-ch-pick-template]").forEach(button => {
        const active=button.dataset.chPickTemplate===id;
        button.setAttribute("aria-pressed", active ? "true" : "false");
        if(active&&indicator) indicator.textContent=button.querySelector(".ch-custom-hub__option-name")?.textContent+" selected.";
      });
    }
    root.querySelectorAll("[data-ch-pick-template]").forEach(btn=>btn.addEventListener("click",()=>pick(btn.dataset.chPickTemplate)));
    if(selected)pick(selected);
    window.scrollTo({top:0,behavior:"instant"});
  }
  const run=()=>roots().forEach(initialize);
  if(document.readyState==="loading") document.addEventListener("DOMContentLoaded",run,{once:true});
  else run();
  document.addEventListener("shopify:section:load",run);
})();